export const TicketDetailsLoadingState = () => (
  <div className="flex animate-pulse flex-col px-8 py-10">
    <div className="mb-8 h-[80px] w-[60%] rounded-2xl bg-grey-100" />
    <div className="mb-8 h-[80px] w-[50%] rounded-2xl bg-grey-100" />
    <div className="mb-12 h-[60px] w-[25%] rounded-2xl bg-grey-100" />
    <div className="mb-8 h-[80px] w-full rounded-2xl bg-grey-100" />
    <div className="mb-8 h-[80px] w-[50%] rounded-2xl bg-grey-100" />
    <div className="h-[60px] w-[25%] rounded-2xl bg-grey-100" />
  </div>
);
